<template>
  <div>
    <modal-form v-model="show" :size="size" :key="uniqueKey" :show-submit="false" text-close="Fechar">
      <template v-slot:title v-if="isAvalista">
        <v-icon class="mr-2"> fas fa-edit </v-icon>
        Documentos - {{ model.Nome }}
      </template>
      <template v-slot:title v-else-if="isVeiculo">
        <v-icon class="mr-2"> fas fa-edit </v-icon>
        Documentos - {{ model.Marca }} - {{ model.Modelo }}
      </template>
      <template v-slot:title v-else>
        <v-icon class="mr-2"> fas fa-edit </v-icon>
        {{ tipo.title }}
      </template>
      <template v-slot:body v-if="hasDocumentoGrid">
        <DocumentoGrid
          :tipo="tipo"
          hasEdit
          alertText="Deseja incluir documentos?"
          :documentoCliente="documentoCliente"
          :codigoProposta="codigoProposta"
          :codigoPessoa="codigoPessoa"
          :hasDocumentosUnificados="hasDocumentosUnificados"
        />
      </template>
      <template v-slot:body v-else>
        <core-grid
          v-model="documentosSelecionados"
          ref="grid"
          modal
          flat
          mobile-breakpoint="0"
          :onRead="onRead"
          :schema="schema"
          :auto-bind="false"
          :hide-all-options="!hasDocumentoEdit && !isAvalista && !showOptions"
          :grid-role="tipo.gridRoleModal"
          :delete-option="!isAvalista && showOptions"
          :add-option="addOption"
          :search-disabled="searchDisabled"
          :selectable="$param.ExportaDocumentosUnificados && hasDocumentosUnificados"
          :singleSelect="false"
          :select-all="false"
          @toggle-select-all="selecionarTodos"
          @input="alterarSelecao"
        >
          <template v-if="$param.ExportaDocumentosUnificados && hasDocumentosUnificados" v-slot:toolbar-append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="ordenarDocumentosUnificados($event)"
                  rounded
                  elevation="4"
                  :disabled="documentosSelecionados.length === 0"
                >Exportar selecionados ({{ documentosSelecionados.length }})
                </v-btn>
              </template>
              <span>Exportar lista de documentos selecionados.</span>
            </v-tooltip>
          </template>
          <template v-if="$param.ExportaDocumentosUnificados && hasDocumentosUnificados" v-slot:[`item.data-table-select`]="{ item }">
            <v-simple-checkbox
              v-if="validarExtensao(item.Extensao)"
              :value="verificarSelecao(item)"
              :disabled="!validarExtensao(item.Extensao) || (!verificarSelecao(item) && documentosSelecionados.length >= 10)"
              @input="alternarSelecao(item)"
            ></v-simple-checkbox>
            <v-tooltip v-else top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="grey lighten-1">mdi-download-off-outline</v-icon>
              </template>
              <span>Somente PDF/PNG/JPG podem ser exportados em arquivo unificado.</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.TipoDocumento`]="{ item }">
            <v-tooltip v-if="isAvalista" top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="mr-2" size="dense" @click="downloadDocumento(item)">
                  ph-file-arrow-down
                </v-icon>
                </template>
                <span>Exportar este documento.</span>
            </v-tooltip>
            <v-tooltip v-else top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="mr-2" size="dense" @click="downloadDocumento(item)">
                  fas fa-file-download
                </v-icon>
              </template>
              <span>Exportar este documento.</span>
            </v-tooltip>
            <a @click="downloadDocumento(item)">
              {{ $aux.TipoDocumento.find((p) => p.value === item.TipoDocumento).text || item.TipoDocumentoDescricao }}
            </a>
          </template>
        </core-grid>
        <DocumentoEdit
          v-if="isAvalista"
          ref="editar"
          isAvalista
          hasEdit
          :tipo="$aux.TipoDocumentoEntidade.Proposta"
          :codigoProposta="codigoProposta"
          :documentoCliente="model.DocumentoFederal"
          :papelAvalista="model.Papel"
          :hasConjuge="model.PropostaAvalistaPF && !!model.PropostaAvalistaPF.CPFConjuge"
          :avalistaConjuge="model.PropostaAvalistaPF"
          :validadeRequired="validadeRequired"
          :nomeAvalista="model.Nome"
          @close="response"
        />
      </template>
    </modal-form>
    <DocumentoEdit
      v-if="hasDocumentoEdit"
      ref="editar"
      hasEdit
      :tipo="tipo"
      :isVeiculo="isVeiculo"
      :codigoVeiculo="model.CodigoIdentificador"
      :isVeiculoZeroKM="model.ZeroKM"
      :codigoProposta="codigoProposta"
      :codigoPessoa="codigoPessoa"
      :documentoCliente="model.DocumentoFederal || model.Cliente?.DocumentoFederal"
      :validadeRequired="validadeRequired"
      @close="response"
    />
    <DocumentoOrdenacao ref="documentoOrdenacao" @exportarDocumentos="exportarDocumentosUnificados"/>
  </div>
</template>

<script>
export default {
  components: {
    DocumentoOrdenacao: () => import('./DocumentoOrdenacao'),
  },
  props: {
    hasDocumentoGrid: { type: Boolean, default: false },
    hasDocumentoEdit: { type: Boolean, default: false },
    showOptions: { type: Boolean, default: false },
    addOption: { type: Boolean, default: true },
    searchDisabled: { type: Boolean, default: false },
    size: { type: String, default: 'md' },
    tipo: { type: Object, required: true }, // 'pessoa' ou 'proposta'
    codigoPessoa: { type: String, default: null },
    codigoProposta: { type: String, default: null },
    documentoCliente: { type: String, default: null },
    validadeRequired: { type: Boolean, default: false },
    isAvalista: { type: Boolean, default: false },
    isVeiculo: { type: Boolean, default: false },
    hasDocumentosUnificados: { type: Boolean, default: false },
  },
  data () {
    return {
      show: false,
      model: {},
      schema: [
        { value: 'TipoDocumento', text: 'Tipo Documento', width: '30%' },
        { value: 'NomeArquivo', text: 'Nome Arquivo' },
        { value: 'DtValidade', text: 'Válido até', format: 'date' },
      ],
      documentosSelecionados: []
    };
  },
  computed: {
    uniqueKey () {
      if (this.isAvalista) {
        return this.model.Codigo
      } else if (this.tipo === this.$aux.TipoDocumentoEntidade.Pessoa) {
        return this.codigoPessoa
      } return this.codigoProposta
    },
  },
  methods: {
    openModal (sender) {
      const th = this
      th.documentosSelecionados = []
      th.show = true;
      if (sender) {
        th.model = sender;
        if (th.tipo === th.$aux.TipoDocumentoEntidade.Pessoa) {
          th.$api.UI.Timeout.GridRefresh(th);
        } else {
          th.$api.UI.Timeout.Default(() => {
            if (th.$refs && th.$refs.grid) {
              th.$refs.grid.refresh();
            } else {
              return 10;
            }
          });
        }
      }
    },
    onRead (options, search) {
      const th = this
      const dto =
        th.tipo === th.$aux.TipoDocumentoEntidade.Pessoa
          ? {
            parameters: [
              { name: 'CodigoPessoa', value: th.codigoPessoa },
              { name: 'CodigoProposta', value: th.codigoProposta },
            ],
          }
          : {
            parameters: [{ name: 'CodigoProposta', value: th.codigoProposta }],
          };

      th.$api.Multiplo.Post(th.tipo.apiEndpoint, dto).then((response) => {
        if (th.$api.UI.PostLoadData(response)) {
          if (th.isVeiculo) {
            const listaVeiculos = response.Data.filter(doc => !doc.NomeArquivo?.includes(th.model.CodigoIdentificador))
            th.isVeiculo ? options.success(response.Data.filter(({ NomeArquivo }) => NomeArquivo.includes(th.model.CodigoIdentificador))) : options.success(listaVeiculos)
          } else {
            const listaFiltrada = response.Data.filter(doc => !doc.NomeArquivo?.includes('Representante Legal') && !doc.NomeArquivo?.includes('Avalista'))
            th.isAvalista ? options.success(response.Data.filter(({ NomeArquivo }) => NomeArquivo.includes(th.model.Nome))) : options.success(listaFiltrada)
          }
        }
      });
    },
    downloadDocumento (current) {
      window.open(
        `${process.env.VUE_APP_ROOT_WEBURL}download.aspx?type=${this.tipo.tipoDownloadDoc}&code=${current.Codigo}`
      );
    },
    refresh () {
      this.$refs.grid.refresh();
    },
    response (data) {
      if (data) this.refresh();
    },
    excluir (current) {
      const th = this
      if (current) {
        this.documentosSelecionados = this.documentosSelecionados.filter(documento => documento.ID !== current.ID)
        const dto = {
          guidID: current.Codigo
        }
        this.$api.Multiplo.Post(th.tipo.apiRemoverDocumento, dto).then(function (data) {
          if (th.$api.UI.PostAction(data)) {
            th.refresh()
          }
        })
      }
    },
    ordenarDocumentosUnificados () {
      this.$refs.documentoOrdenacao.openModal(this.documentosSelecionados)
    },
    exportarDocumentosUnificados (listaOrdenada) {
      const documentos = listaOrdenada.map((documento, index) => ({
        url: `${process.env.VUE_APP_ROOT_WEBURL}download.aspx?type=${this.tipo.tipoDownloadDoc}&code=${documento.Codigo}`,
        extensao: documento.Extensao,
        ordem: index + 1
      }))
      const dto = {
        files: documentos
      }
      this.$api.Multiplo.MergeFiles(dto).then((response) => {
        const blob = new Blob(
          [new Uint8Array(response)],
          { type: 'application/pdf' }
        )
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank');
      })
    },
    validarExtensao (extensao) {
      return extensao === 'pdf' || extensao === 'jpg' || extensao === 'jpeg' || extensao === 'png'
    },
    verificarSelecao (item) {
      return this.documentosSelecionados.some(documento => documento.ID === item.ID)
    },
    desabilitarSelecao (item) {
      const itemSelecionado = this.verificarSelecao(item)
      return (!this.validarExtensao(item.Extensao) || (!itemSelecionado && this.documentosSelecionados.length >= 10))
    },
    selecionarTodos (props) {
      if (props.value) {
        const docuemntosValidos = props.items.filter(documento => this.validarExtensao(documento.Extensao))
        this.documentosSelecionados = docuemntosValidos.slice(0, 10)
      } else {
        this.documentosSelecionados = []
      }
    },
    alterarSelecao (novaSelecao) {
      const docuemntosValidos = novaSelecao.filter(documento => this.validarExtensao(documento.Extensao))
      this.documentosSelecionados = docuemntosValidos.slice(0, 10)
      if (this.documentosSelecionados.length >= 10) {
        this.$api.UI.ShowAlert('', 'Selecionados 10 documentos (limite). Para selecionar outros, desmarque alguns.')
      }
    },
    alternarSelecao (item) {
      const itemSelecionado = this.verificarSelecao(item);
      if (itemSelecionado) {
        this.documentosSelecionados = this.documentosSelecionados.filter(documento => documento.ID !== item.ID)
        return
      }
      if (this.documentosSelecionados.length >= 10) {
        return
      }
      this.documentosSelecionados = [
        ...this.documentosSelecionados,
        item
      ]
      if (this.documentosSelecionados.length >= 10) {
        this.$api.UI.ShowAlert('', 'Selecionados 10 documentos (limite). Para selecionar outros, desmarque alguns.')
      }
    },
  },
};
</script>
